import React, { useState } from "react";
import "./FormSuccess.scss";
import form_success_icon from "../../../assets/images/form_success_icon.svg";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { useNavigate } from "react-router-dom";
import SalesService from "../../../Services/SalesService";
import { OverlayLoader } from "../../Loader/Loader";

const FormSuccess = ({ parsedData, formData, formId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formDataListing = [
    {
      text: "Program Name",
      value: parsedData?.[1]?.["1_0"]?.["pi_program_name"] || "--",
    },
    {
      text: "Program Type",
      value: formData?.form_type === 1 ? "Prepaid/Debit" : "Credit",
    },
    {
      text: "Contact Name",
      value: parsedData?.[0]?.["0_0"]?.["pd_client_name"] || "--",
    },
    {
      text: "Phone Number",
      value: parsedData?.[0]?.["0_2"]?.["ci_companyPhone"] || "--",
    },
    {
      text: "Region",
      value: parsedData?.[0]?.["0_0"]?.["pd_region"] || "",
    },
    {
      text: "Time Zone",
      value: parsedData?.[0]?.["0_0"]?.["pd_team_avail"] || "--",
    },
    {
      text: "Bank",
      value: parsedData?.[0]?.["0_2"]?.["ci_businessName"] || "--",
    },
    {
      text: "BIN",
      value: parsedData?.[2]?.["2_0"]?.["cn_bin_no"] || "--",
    },
    {
      text: "Financial Institution",
      value: parsedData?.[0]?.["0_4"]?.["cp_afi_inst_name"] || "--",
    },
  ];

  const generatePdf = async () => {
    try {
      setLoading(true);
      const type = formData?.form_type === 1 ? "prepaid" : "credit";
      const response = await SalesService.pdfGeneration(formId, type);
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      return console.log(response);
    } catch (error) {
      console.error("Error:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <OverlayLoader />}
      <div className="form_success_container">
        <div className="form_success_icon">
          <img src={form_success_icon} alt="" />
        </div>
        <div className="form_success_heading">
          Request Submitted Successfully!
        </div>
        <div className="form_success_sub_heading">
          Your requested project case submitted successfully.
        </div>
        <div className="form_success_inner">
          {formDataListing.map((card, index) => (
            <div key={index} className="form_success_flex">
              <div className="form_success_flex_h">{card.text}</div>
              <div className="form_success_flex_v">{card.value}</div>
            </div>
          ))}
        </div>
        <div className="form_success_btn_flex">
          <I2cButton
            size="medium"
            variant="secondary gray"
            onClick={generatePdf}
            disabled={!formId}
          >
            <I2cIcon
              name="linear-import-2"
              label="placeholder"
              slot="prefix"
            ></I2cIcon>
            Download PDF
          </I2cButton>
          <I2cButton
            size="medium"
            onClick={() => {
              navigate("/");
            }}
          >
            Back to Home
          </I2cButton>
        </div>
      </div>
    </>
  );
};

export default FormSuccess;
